export type NewsletterFormData = {
  email: string;
  consentsDataProcessing?: boolean;
  language?: string;
  nodeId?: string;
};

const payloadEnrichment = (requestData: NewsletterFormData) => {
  return {
    email: requestData.email,
    language: requestData.language?.toUpperCase(),
    'privacy-checkbox-newsletter': requestData.consentsDataProcessing ? 1 : 0,
    'privacy-checkbox-default': requestData.consentsDataProcessing ? 1 : 0,
    node_id: requestData.nodeId,
  };
};

export const subscribeNewsletterAPI = async (
  requestData: NewsletterFormData
) => {
  const NEWSLETTER_URL = process.env.NEXT_PUBLIC_NEWSLETTER_URL;
  const NEWSLETTER_TOKEN = process.env.NEXT_PUBLIC_NEWSLETTER_TOKEN;

  const payload = payloadEnrichment(requestData);

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${NEWSLETTER_TOKEN}`,
    },
    body: JSON.stringify(payload),
  };

  return fetch(`${NEWSLETTER_URL}`, options);
};
